import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import JsonExcel from 'vue-json-excel'
import Vuelidate from 'vuelidate'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

import '@/assets/css/main.scss'

import stringMaxLengthFilter from './filters/stringMaxLength.filter'

// Plugins
import '@/utils/filters/dateFilters.js'

const apiBugsnag = process.env.VUE_APP_API_BUGSNAG
if (apiBugsnag) {
  Bugsnag.start({
    apiKey: apiBugsnag,
    plugins: [new BugsnagPluginVue()]
  })
}

Vue.use(Vuelidate)
Vue.filter('stringMaxLength', stringMaxLengthFilter)
Vue.component('downloadExcel', JsonExcel)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (apiBugsnag) {
  const bugsnagVue = Bugsnag.getPlugin('vue')
  bugsnagVue.installVueErrorHandler(Vue)
}
